import React from "react";
import Loader from "Components/Loader";
import { useGetProductsQuery } from "hooks/ProductsManagement/useGetProductsQuery";
import { Divider } from "antd";

type Props = { payload: any; setPayload: any };

const ProductSelection = ({ payload, setPayload }: Props) => {
  const { data, isPending } = useGetProductsQuery({});

  return (
    <div>
      <div>
        {isPending && <Loader />}
        <div className="mb-3">
          <div className="flex text-sm gap-[40px] font-bold">
            <div className="w-3/12">Name</div>
            <div className="w-9/12">Unit Price</div>
          </div>
          <Divider />
        </div>

        <div className="h-[350px] overflow-y-scroll">
          {!isPending &&
            data?.data?.docs &&
            data?.data?.docs.map(({ name, unitPrice }: any) => (
              <div className="mb-3">
                <div className="flex text-sm gap-[40px]">
                  <div className="w-3/12">{name}</div>
                  <div className="w-9/12">{unitPrice}</div>
                </div>
                <Divider />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ProductSelection;
